import Image from "next/image";
import { montserrat, playfairDisplay, type Translationtype } from "utils";
import { BsStarFill } from "react-icons/bs";

interface IMagicAiModalContentProps {
  t: Translationtype;
}

export function MagicAiModalContent({ t }: IMagicAiModalContentProps) {
  return (
    <div className="bg-white p-3 rounded-[14px]">
      <div className="absolute right-0 bottom-0">
        <div className="relative w-[8rem] sm:w-[10rem] md:w-[13rem] h-[9rem] sm:h-[12rem] md:h-[15rem] mb-[1rem] sm:mb-0 ">
          <Image
            src="/assets/img/jinny.png"
            alt="Jinny"
            fill
            className="object-cover"
          />
        </div>
      </div>
      <div className="md:mr-[6rem]">
        <Image
          src="/assets/logo/EJ_logo_long_black.svg"
          priority
          width={200}
          height={50}
          alt="LOGO"
          className="max-w-[200px] mb-4"
        />
        <h2
          className={`${playfairDisplay.className} text-xl md:text-3xl text-start mr-auto font-semibold flex flex-row gap-3 items-center text-[#1e293b] mb-4`}
        >
          <BsStarFill />
          {t("upgradeToPremium.modal.premiumPackage")}
        </h2>
        <div className="max-w-[10rem] sm:max-w-[12rem] md:max-w-[14rem] mr-auto mb-5">
          <p
            className={`${montserrat.className} text-sm sm:text-base md:text-lg font-semibold`}
          >
            {t("upgradeToPremium.modal.enjoyTitle")}
          </p>
          <p
            className={`${montserrat.className} text-sm sm:text-base md:text-lg`}
          >
            {t("upgradeToPremium.modal.enjoyDescription")}
          </p>
        </div>
      </div>
    </div>
  );
}
